import React, { useState, useEffect } from "react";
import SampleEditor from "./SampleEditor";
import { fetchJson, post } from "../../lib/Fetching";
import ScheduleList from "./ScheduleList";

export default function RegisterRetestSample({ sampleId, onCancel, onCompleted }) {
  const [sample, setSample] = useState(null);
  const [newSample, setNewSample] = useState(null);
  const [route, setRoute] = useState("pick_schedule");

  useEffect(
    () => {
      fetchJson("/lims_sample_reporting/samples/" + sampleId + ".json").then((sample) => {
        setSample(sample);
      });
    },
    [sampleId]
  );

  if (!sample) return null;

  const createSamples = (samples, reason) => {
    return post("/registration/samples/create_retests", {
      sample_id: sampleId,
      samples,
      reason,
    }).then(onCompleted);
  };

  const pickSchedule = (test_schedule, count) => {
    const basketItems = [
      {
        product: { id: sample.product_id, name: sample.product_name },
        test_schedule,
        count: 1,
      },
    ];
    post("/registration/samples/new", {
      company_id: sample.company_id,
      company_branch_id: sample.company_branch_id,
      data: basketItems,
      retesting_sample_id: sampleId,
    }).then((json) => {
      setNewSample(json.samples[0]);
      setRoute("register");
    });
  };

  if (route === "pick_schedule") {
    console.log(sample);
    return (
      <div style={{ maxWidth: 1000 }}>
        <h4 className="text-center">Select schedule for re-test sample</h4>
        <p className="text-center">
          The suite for the current sample is '{sample.client_suite_name}'
        </p>
        <ScheduleList product_id={sample.product_id} onlyPick pickSchedule={pickSchedule} />
      </div>
    );
  }

  return (
    <div style={{ display: "table", margin: "0 auto" }}>
      <SampleEditor
        samples={[newSample]}
        handleSubmit={createSamples}
        buttonTitle={I18n.t("register_retest_sample")}
        showReason={true}
        company_id={newSample.company_id}
        isSubmitting={false}
      />
    </div>
  );
}
